export default __webpack_public_path__ + "static/media/leran-background-circle.a5c0ee3e.svg";